module.exports = __webpack_public_path__ + "static/media/close.225af29b.svg";